module.exports = __webpack_public_path__ + "img/email.4b78361c.svg";